// Imports
import Alpine from 'alpinejs';
import EmblaCarousel from 'embla-carousel'
import Autoplay from 'embla-carousel-autoplay';
import gsap from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Hammer from 'hammerjs';
// import { Core } from '@unseenco/taxi';
// import { Transition } from '@unseenco/taxi';
import marquee3k from 'marquee3000';
// import Lottie from 'lottie-web';
// import { replaceColor } from 'lottie-colorify';
// import { LottiePlayer } from '@lottiefiles/lottie-player';
// import { LottieInteractivity } from '@lottiefiles/lottie-interactivity';


gsap.registerPlugin(ScrollTrigger);

// import AutoHeight from 'embla-carousel-auto-height'

// Alpine
window.Alpine = Alpine;
Alpine.start();

const isMobile = window.innerWidth <= 768; 
const isDesktop = window.innerWidth > 768; 

// class FadeTransition extends Transition {
//     onLeave({ from, done }) {
//       from.style.transition = 'opacity 0.5s ease-out';
//       from.style.opacity = '0';
//       from.addEventListener('transitionend', done, { once: true });
//     }
  
//     onEnter({to, done}) {
//         animateElements('.f-up');
//         toggleNavElements();

//         if (document.querySelector('.embla')) {
//             emblaSlider();
//         }
//         done(console.log('done'));

//     }
// }

// const taxi = new Core({
//     transitions: {
//         default: FadeTransition,
//       }
// });

function emblaSlider() {
    const emblaNodes = document.querySelectorAll('.embla'); // Select all embla containers
    const options = { loop: true };
  
    emblaNodes.forEach((emblaNode) => {
      const emblaApi = EmblaCarousel(emblaNode, options, [
        Autoplay({ playOnInit: true, delay: 3000 }),
      ]);
    });
  }



  // function runLottie() {
  //   const players = document.querySelectorAll("lottie-player");
  
  //   if (players.length === 0) {
  //     console.log('feck');
  //     return;
  //   } else {
  //     console.log('let animate');
  //   }
  
  //   players.forEach((player) => {
  //     player.addEventListener("ready", () => {
  //       player.play(); // Play the animation automatically when ready
  //     });
 
  //   });
  // }
  
  // runLottie();
  

  document.addEventListener('DOMContentLoaded', function() {
    function animationStart() {
      document.getElementById('logo').classList.add('fin');
    }
    setTimeout(animationStart, 50);
  });


// function animateElements(el, container) {
//     gsap.from(el, {
//         y: 10,
//         opacity: 0,
//         duration: 0.5,
//         ease: 'expo.out',
//         stagger: 0.1,
//         scrollTrigger: {
//             trigger: '.f-up',
//             start: 'top 90%', // Starts when the element is 90% into the viewport
//             toggleActions: 'play none none none',
//             immediateRender: false,
//             once: true,
//         },
//     });


// }

function animateChildren(container) {

    gsap.utils.toArray(container).forEach((container) => {
        const children = container.querySelectorAll(':scope > *');

        gsap.from(children, {
            y: 10,
            opacity: 0,
            duration: 0.6,
            ease: 'expo.out',
            stagger: 0.1,
            scrollTrigger: {
                trigger: container,
                start: 'top 90%', // Starts when the container is 90% into the viewport
                toggleActions: 'play none none none',
                immediateRender: false,
                once: true,
            },
        });
    });

}

// gsap.utils.toArray('.f-up').forEach((textBlock) => {
//   gsap.from(textBlock, {
//       opacity: 0,
//       y: 50,
//       duration: 1,
//       ease: 'expo.out',
//       scrollTrigger: {
//           trigger: textBlock,
//           start: 'top 50%',
//           stagger: 0.1,
//           toggleActions: 'play none none none',
//           once: false, 
//       },
//   });
// });


animateChildren('.animateChildrenUp');
animateChildren('.grid');
animateChildren('.footer');



function toggleNavElements() {
  const tagline = document.querySelector('[data-tagline]');
  const logo = document.querySelector('[data-logo]');
  const isHomePage = window.location.pathname === '/' || window.location.pathname === '/index.html'; // Adjust as needed

  if (isDesktop) {
    if (isHomePage) {
      tagline.classList.add('visible');
      logo.classList.remove('visible');
    } else {
      tagline.classList.remove('visible');
      logo.classList.add('visible');
    }
  } 
}


window.scrollTo(0, 0);
emblaSlider();
// animateElements('.nav-up');
// animateElements('.f-up');
toggleNavElements();

marquee3k.init();


const giftcard = document.querySelector('.giftcard');
let isGiftcardOpen = false;
let initialScrollY = 0;
const scrollThreshold = 100;

function toggleGiftcard() {
    isGiftcardOpen = !isGiftcardOpen;
    giftcard.classList.toggle('giftcard--active', isGiftcardOpen);

    if (isGiftcardOpen) {
        initialScrollY = window.scrollY;
    } else {
        giftcard.classList.remove('giftcard--active');
    }
}

function handleScroll() {
    if (isGiftcardOpen) {
        const scrollDistance = Math.abs(window.scrollY - initialScrollY);
        if (scrollDistance > scrollThreshold) {
            isGiftcardOpen = false;
            giftcard.classList.remove('giftcard--active');
        }
    }
}

window.addEventListener('scroll', handleScroll);

document.querySelector('#giftCardButton').addEventListener('click', toggleGiftcard);


// Function to save menu positions to localStorage
const savePosition = () => {
  const positions = [];
  document.querySelectorAll('.menu').forEach((element) => {
    const position = {
      id: element.id,
      left: element.style.left,
      top: element.style.top,
      zIndex: element.style.zIndex
    };
    positions.push(position);
  });
  localStorage.setItem('menuPositions', JSON.stringify(positions));
};

// Function to load menu positions from localStorage
const loadPosition = () => {
  const savedPositions = JSON.parse(localStorage.getItem('menuPositions')) || [];
  if (savedPositions.length === 0) {
    if(isDesktop) {
      shuffleMenus();
    }
  } else {
    savedPositions.forEach((savedPosition) => {
      const element = document.getElementById(savedPosition.id);
      if (element) {
        element.style.left = savedPosition.left || '0px';
        element.style.top = savedPosition.top || '0px';
        element.style.zIndex = savedPosition.zIndex || '1000';
        element.style.position = 'absolute';
      }
    });
  }
};

// Function to make an element draggable
const makeDraggable = (element) => {
  let isDragging = false;
  let startX, startY, initialLeft, initialTop;

  const onMouseDown = (e) => {
    isDragging = true;
    initialLeft = element.offsetLeft;
    initialTop = element.offsetTop;
    startX = e.clientX;
    startY = e.clientY;

    // Bring the clicked menu to the front
    const maxZIndex = Math.max(...Array.from(document.querySelectorAll('.menu')).map(el => parseInt(el.style.zIndex || '0')));
    element.classList.add('active');
    element.style.zIndex = maxZIndex + 1;

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
    e.preventDefault();
  };

  const onMouseMove = (e) => {
    if (!isDragging) return;

    const dx = e.clientX - startX;
    const dy = e.clientY - startY;

    element.style.left = `${initialLeft + dx}px`;
    element.style.top = `${initialTop + dy}px`;
  };

  const onMouseUp = () => {
    isDragging = false;
    savePosition();
    document.removeEventListener('mousemove', onMouseMove);
    document.removeEventListener('mouseup', onMouseUp);
    element.classList.remove('active');
  };

  element.addEventListener('mousedown', onMouseDown);
};

// Initialize draggable menus when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', () => {
  if(isDesktop) {
  loadPosition();
  document.querySelectorAll('.menu').forEach((menu) => {
    makeDraggable(menu);
    // Ensure each menu has a valid initial z-index
    if (!menu.style.zIndex) {
      menu.style.zIndex = '1000';
    }
  });
  }
});

const shuffleMenus = () => {
  // console.log("Menus shuffled!");

  const menus = Array.from(document.querySelectorAll('.menu'));
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;

  const centerX = viewportWidth / 2;
  let centerY, shuffleAreaHeight;

  if (viewportHeight > 900) {
    centerY = viewportHeight / 2.5;
    shuffleAreaHeight = viewportHeight * 0.8;
  } else {
    centerY = viewportHeight / 3;
    shuffleAreaHeight = viewportHeight * 0.7;
  }

  const shuffleAreaWidth = viewportWidth * 0.9;
  const margin = 20;
  const minDistance = 300;
  const placedMenus = [];

  // Sort menus by area (width * height) in ascending order (smallest first)
  menus.sort((a, b) => {
    const areaA = a.offsetWidth * a.offsetHeight;
    const areaB = b.offsetWidth * b.offsetHeight;
    return areaA - areaB;
  });

  // Reverse the array to process larger menus first
  // menus.reverse();

  // Assign position and z-index for each menu
  menus.forEach((menu, index) => {
    const menuWidth = menu.offsetWidth;
    const menuHeight = menu.offsetHeight;

    let attempts = 0;
    let validPosition = false;
    let left, top;

    while (!validPosition && attempts < 50) {
      const maxX = shuffleAreaWidth - menuWidth - margin * 2;
      const maxY = shuffleAreaHeight - menuHeight - margin * 2;

      const randomX = (Math.random() - 0.5) * maxX;
      const randomY = (Math.random() - 0.5) * maxY;

      left = centerX + randomX - menuWidth / 2;
      top = centerY + randomY - menuHeight / 2;

      left = Math.max(margin, Math.min(viewportWidth - menuWidth - margin, left));
      top = Math.max(margin, Math.min(viewportHeight - menuHeight - margin, top));

      validPosition = placedMenus.every(placedMenu => {
        const dx = left - placedMenu.left;
        const dy = top - placedMenu.top;
        const distance = Math.sqrt(dx * dx + dy * dy);
        return distance >= minDistance;
      });

      attempts++;
    }

    menu.style.left = `${left}px`;
    menu.style.top = `${top}px`;
    menu.style.position = 'absolute';
    menu.style.zIndex = menus.length - index;  

    placedMenus.push({ left, top });
  });

  if(isDesktop) {
    savePosition();
  }
};


const stackMenus = () => {
  const menus = Array.from(document.querySelectorAll('.menu'));
  const container = document.querySelector('.menu-container');
  const wrapMenu = document.querySelector('.wrap--menu');
  const windowWidth = window.innerWidth;
  const margin = 10;

  let rows = [];
  let currentRow = [];
  let currentRowWidth = 0;
  let rowHeight = 0;

  // Organize menus into rows based on window width
  menus.forEach((menu) => {
    const menuWidth = menu.offsetWidth;
    const menuHeight = menu.offsetHeight;
    const totalMenuWidth = menuWidth + margin;

    console.log(menuHeight + margin)

    if (currentRowWidth + totalMenuWidth > windowWidth && currentRow.length > 0) {
      // Push current row to rows array
      rows.push({
        menus: currentRow,
        width: currentRowWidth - margin, // Subtract margin after the last menu
        height: rowHeight,
      });
      // Reset for the new row
      currentRow = [];
      currentRowWidth = 0;
      rowHeight = 0;
    }

    currentRow.push(menu);
    currentRowWidth += totalMenuWidth;
    rowHeight = Math.max(rowHeight, menuHeight);
    
  });

  // Add the last row if it exists
  if (currentRow.length > 0) {
    rows.push({
      menus: currentRow,
      width: currentRowWidth - margin,
      height: rowHeight,
    });
  }

  // Position menus within each row
  let currentY = 0;
  rows.forEach((row) => {
    const startX = (windowWidth - row.width) / 2; // Center the row
    let currentX = startX;

    row.menus.forEach((menu) => {
      const menuWidth = menu.offsetWidth;
      const menuHeight = menu.offsetHeight;

      menu.style.position = 'absolute';
      menu.style.left = `${currentX}px`;
      menu.style.top = `${currentY}px`;

      currentX += menuWidth + margin;
    });

    currentY += row.height + margin;
  });

  container.style.position = 'relative'; // Ensure container positions its children absolutely
  container.style.height = `${currentY}px`;
  container.style.width = `${windowWidth}px`;
};




document.addEventListener('DOMContentLoaded', () => {
  if(isDesktop) {
  loadPosition();
  document.querySelectorAll('.menu--shuffle').forEach((menu) => {
    makeDraggable(menu);
    if (!menu.style.zIndex) {
      menu.style.zIndex = '1';
    }
  });

  // Add event listeners for shuffle and stack buttons
  const shuffleButton = document.getElementById('shuffleButton');
  const stackButton = document.getElementById('stackButton');

  if (shuffleButton) {
    shuffleButton.addEventListener('click', () => {
      shuffleMenus();
      // console.log('Shuffle button clicked');
    });
    
  }

  if (stackButton) {
    stackButton.addEventListener('click', () => {
      stackMenus();
      // console.log('Stack button clicked');
    });
  }
}
});

let resizeTimer;

window.addEventListener('resize', () => {
  if(isDesktop) {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    const wrapMenu = document.querySelector('.wrap--menu');
    if (!wrapMenu.classList.contains('menu--stack')) {
      shuffleMenus();
    }
  }, 300);
  }
});


  // Declare wrapMenu outside so it's accessible in the event listener
const wrapMenu = document.querySelector('.wrap--menu');
const menuButtons = document.querySelectorAll('.menuButton');

menuButtons.forEach(button => {
  button.addEventListener('click', function() {
    // console.log('menu button clicked'); // Verify that the event is triggered

    const menus = document.querySelectorAll('.menu');
    // console.log('menus:', menus); // Check if menus are being selected

    menus.forEach((menu, index) => {
      setTimeout(() => {
        // console.log('adding menu--active to', menu); // Ensure class is being added
        menu.classList.add('menu--active');
      }, index * 100); 
    });
  });

  if(isDesktop) {
    if (wrapMenu && wrapMenu.classList.contains('menu--stack')) {
      wrapMenu.classList.remove('menu--stack');
      wrapMenu.classList.add('menu--shuffle');
      shuffleMenus();
    }
  }
});

document.addEventListener('click', function(e) {
  let target = e.target;

  while (target && target.tagName !== 'A') {
    target = target.parentElement;
  }

  if (target && target.tagName === 'A' && target.getAttribute('href').startsWith('#')) {
    e.preventDefault();
    const targetId = target.getAttribute('href');

    if (targetId) {
      const targetElement = document.querySelector(targetId);
      
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  }
});



// document.addEventListener('click', function(e) {
//   if (e.target.tagName === 'A') {
//     e.preventDefault();
//     console.log('clicked an anchor with id');

//     // const targetId = e.target.getAttribute('href');
//     // const targetElement = document.querySelector(targetId);

//     // if (targetElement) {
//     //   targetElement.scrollIntoView({
//     //     behavior: 'smooth'
//     //   });
//     // }
//   }
// });




document.querySelectorAll(".gallery").forEach((gallery) => {
  const images = gallery.querySelectorAll(".gallery__image");
  const captions = gallery.querySelectorAll(".gallery__image figcaption");

  images.forEach((image, index) => {
    const isLastImage = index === images.length - 1;

    gsap.fromTo(
      image.querySelector("img"),
      {
        opacity: 1,
        scale: !isMobile ? 0.9 : 1,
      },
      {
        opacity: isLastImage ? 1 : 0,
        scale: 1,
        ease: 'none',
        scrollTrigger: {
          trigger: image,
          start: "top top",
          end: "bottom top",
          scrub: true,
        },
      }
    );
  });

  captions.forEach((caption, index) => {
    gsap.fromTo(
      caption,
      {
        opacity: 1,
      },
      {
        opacity: 0,
        ease: 'expo.out',
        scrollTrigger: {
          trigger: caption,
          start: "top 20%",
          end: "bottom 80%",
          scrub: true,
        },
      }
    );
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const overlay = document.querySelector('.menuSingle__overlay');
  const overlayContent = overlay.querySelector('.overlay-content');
  const body = document.querySelector('body');
  let lastScrollY = window.scrollY;

  const closeOverlay = () => {
    overlay.classList.remove('active');
    body.classList.remove('overlay--open');
    setTimeout(() => overlayContent.innerHTML = '', 300);
  };

  document.querySelectorAll('.menu__list button').forEach(button => {
    button.addEventListener('click', () => {
      const targetMenu = document.getElementById(button.getAttribute('data-target'));

      body.classList.add('overlay--open');


      if (targetMenu) {
        overlayContent.innerHTML = targetMenu.innerHTML;
        overlayContent.querySelectorAll('.menu').forEach((menu) => {
          menu.classList.add('menu--active');
          if(isDesktop) {
            makeDraggable(menu);
          }
        });
        if(isDesktop) {
          shuffleMenus();
        }
        overlay.classList.add('active');
      }
    });
  });

  overlay.querySelector('.overlay-close').addEventListener('click', closeOverlay);
  overlay.addEventListener('click', (e) => {
    if (!overlayContent.contains(e.target)) closeOverlay();
  });

  // Close overlay on scroll up or down by 200px
  window.addEventListener('scroll', () => {
    if(isDesktop) {
    const scrollDistance = Math.abs(window.scrollY - lastScrollY);
    if (scrollDistance > 400) {
      closeOverlay();
    }
    }
  });
});




// Ok we have menus inside two different types of containers
// 1. We need to sort the menus by height so the tallest is at the back so we're using z-index
// 2. We want to be able to clikc the front menus and for the it to loop to the back and does this continously
// 3. We we want to be able to click any menu to bring it to the front, this then becomes the new top menu
// 4. We need a way to count all the menus and that can't be based on the container because some menus are loaded dynamically 
// You could use top and end class to keep track of the front and back
// The front and back could have z-indexs of 0 and 10 because we will never and more menus then that the other menus need to maintain z-indexs inbetween these numbers
// This is why we need to keep it

// CSS classes (add to your stylesheet):
/*
.menu-transition {
  transition: transform 0.3s ease-out;
}

.menu-to-back {
  transform: translateY(0);
}

.menu-to-front {
  transform: translateY(-10px);
}
*/

if (isMobile) {
  const menuContainers = [
    ...Array.from(document.querySelectorAll('.wrap--menu, .overlay-content')),
    ...Array.from(document.querySelectorAll('.menu__single'))
  ];

  menuContainers.forEach(initializeMenus);

  function initializeMenus(container) {
    const menus = Array.from(container.querySelectorAll('.menu'));
    sortMenusByHeight(menus);
    setInitialPositions(menus);
    container.addEventListener('click', handleMenuClick);
  }

  function sortMenusByHeight(menus) {
    menus.sort((a, b) => b.offsetHeight - a.offsetHeight);
    menus.forEach((menu, index) => {
      // Assign z-index so the tallest menu (index 0) has the lowest z-index
      menu.style.zIndex = index + 1;
    });
  }

  function setInitialPositions(menus) {
    const maxOffset = 250;
    const offsetStep = menus.length > 1 ? maxOffset / (menus.length - 1) : 0;
    menus.forEach((menu, index) => {
      menu.style.top = `${index * offsetStep}px`;
    });
  }

  function handleMenuClick(event) {
    const clickedMenu = event.target.closest('.menu');
    if (!clickedMenu) return;

    const container = clickedMenu.closest('.wrap--menu, .overlay-content, .menu__single');
    const menus = Array.from(container.querySelectorAll('.menu'));
    const menuCount = menus.length;

    animateMenuShuffle(clickedMenu);
    updateMenuOrder(clickedMenu, menus, menuCount);
  }

  function animateMenuShuffle(menu) {
    menu.classList.add('shuffle');
    setTimeout(() => {
      menu.classList.remove('shuffle');
    }, 200);
  }

  function updateMenuOrder(clickedMenu, menus, menuCount) {
    const clickedZIndex = parseInt(clickedMenu.style.zIndex, 10);

    if (clickedZIndex === menuCount) {
      // Clicked menu is on top, move it to the back
      menus.forEach(menu => {
        const currentZIndex = parseInt(menu.style.zIndex, 10);
        if (currentZIndex < menuCount) {
          menu.style.zIndex = (currentZIndex + 1).toString();
        }
      });
      clickedMenu.style.zIndex = '1';
      transitionMenuPosition(clickedMenu, 'back');
    } else {
      // Move clicked menu to the front
      menus.forEach(menu => {
        const currentZIndex = parseInt(menu.style.zIndex, 10);
        if (currentZIndex > clickedZIndex) {
          menu.style.zIndex = (currentZIndex - 1).toString();
        }
      });
      clickedMenu.style.zIndex = menuCount.toString();
      transitionMenuPosition(clickedMenu, 'front');
    }
  }

  function transitionMenuPosition(menu, position) {
    menu.classList.add('menu-transition');
    
    setTimeout(() => {
      if (position === 'back') {
        menu.classList.add('menu-to-back');
        menu.classList.remove('menu-to-front');
      } else {
        menu.classList.add('menu-to-front');
        menu.classList.remove('menu-to-back');
      }

      // Remove the transition class after the animation is complete
      setTimeout(() => {
        menu.classList.remove('menu-transition', 'menu-to-back', 'menu-to-front');
      }, 300); // This should match the transition duration in your CSS
    }, 0);
  }
}


// if (isMobile) {
//   const menuButton = document.querySelector('.menuButton');
//   const otherNavLinks = document.querySelectorAll('.nav__link');

//   menuButton.addEventListener('click', function() {
//     const span = this.querySelector('span');
//     const isOpen = span.textContent === 'Menus';

//     // Toggle button text between "Menus" and "Close"
//     span.textContent = isOpen ? 'Close' : 'Menus';

//     // Toggle the class for all other nav links to fade them
//     otherNavLinks.forEach(link => {
//       if (link !== this.parentElement) {
//         link.classList.toggle('menu-open', isOpen); // Add 'menu-open' if it's open, remove if closed
//       }
//     });
//   });
// }

// if (isMobile) {
//   const otherNavLinks = document.querySelectorAll('.nav__link:not([x-data])');  // Exclude the one with x-data
  
//   document.querySelector('.menuButton').addEventListener('click', function() {
//     const isOpen = this.querySelector('span').textContent === 'Close';

//     // Toggle the class for all other nav links to fade them
//     otherNavLinks.forEach(link => {
//       link.classList.toggle('menu-open', isOpen); // Add 'menu-open' if it's open, remove if closed
//     });
//   });
// }